import {AutomaticPremiumLoanProvision as AutomaticPremiumLoanProvisionLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

type AutomaticPremiumLoanProvisionProps = {
  automaticPremiumLoanProvisionLetter: AutomaticPremiumLoanProvisionLetter;
};

const AutomaticPremiumLoanProvision = (props: AutomaticPremiumLoanProvisionProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.automaticPremiumLoanProvisionLetter.date)} />
      <CardField name="Owner Name" value={props.automaticPremiumLoanProvisionLetter.ownerName} />
      <CardField name="Owner Address" value={props.automaticPremiumLoanProvisionLetter.ownerAddress!.fullAddress} />
      <CardField name="Policy Number" value={props.automaticPremiumLoanProvisionLetter.policyNumber} />
      <CardField
        name="Premium Paid Through Date"
        value={toFormattedDateAsUTC(props.automaticPremiumLoanProvisionLetter.premiumPaidThroughDate)}
      />
      <CardField name="Loan Interest Rate" value={props.automaticPremiumLoanProvisionLetter.loanInterestRate} />
      <CardField name="Insured Name" value={props.automaticPremiumLoanProvisionLetter.insuredName} />
      <CardField
        name="Current Loan Balance"
        value={toMoneyValue(props.automaticPremiumLoanProvisionLetter.currentLoanBalance)}
      />
      <CardField name="Agent Number" value={props.automaticPremiumLoanProvisionLetter.agentNumber} />
    </>
  );
};

export default AutomaticPremiumLoanProvision;
